import { type DefaultOpts, getNow } from './datetime'

export type BindingSource = {
  type: 'dateTime'
  dataType: 'date'
  options?: {
    startOfDay?: boolean
    offset?: number
  }
}

export type Binding = {
  id: string
  source: BindingSource
  bindingType: string
  type: 'binding'
  label: string
  format: {
    type: string
  }
}

const CACHE_TLL = 5000 // 5 seconds

type CacheValue = {
  value: string
  cachedAt: number
}
const getDateSourceValueCache = new Map<string, CacheValue>()

// TODO (michael-adalo): find a better way than clobbering the same variable name
export const getDateSourceValue = (
  binding: Binding,
  isAction = false,
  { now = getNow() }: DefaultOpts = {}
): string => {
  const exactTimeNow = getNow().valueOf()

  // TODO(enzo): revisit this, binding.id is undefined in some scenarios, specifically for "Start of today"
  if (binding.id && getDateSourceValueCache.has(binding.id)) {
    const cached = getDateSourceValueCache.get(binding.id) as CacheValue
    if (exactTimeNow - cached.cachedAt < CACHE_TLL) {
      return cached.value
    }
  }

  const { source } = binding
  const options = source.options ?? {}

  if (options.startOfDay) {
    now = now.startOf('day')
  }

  if (options.offset) {
    if (options.offset % 1 === 0) {
      if (Math.abs(options.offset) === 180) {
        // return a `true` 6 month offset
        now = now.plus({ months: options.offset < 0 ? -6 : 6 })
      } else if (Math.abs(options.offset) === 365) {
        // return a `true` 1 year offset
        now = now.plus({ years: options.offset < 0 ? -1 : 1 })
      } else {
        now = now.plus({ days: options.offset })
      }
    } else {
      now = now.plus({ minutes: options.offset * 24 * 60 })
    }
  }

  if (isAction) {
    now = now.toUTC()
  }

  const result = now.toISO()
  getDateSourceValueCache.set(binding.id, {
    value: result,
    cachedAt: exactTimeNow,
  })

  return result
}
